import { render, staticRenderFns } from "./VFatherProAnamANxAL.vue?vue&type=template&id=1330f9cf"
import script from "./VFatherProAnamANxAL.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamANxAL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports